import { Typography } from "@/components/atoms";
import { getCountryFlagSrc } from "@/utils/getCountryFlagSrc";

export interface VehiclePreviewData {
  title: string;
  plateLine: string;
  rows: Array<{ label: string; value: string | null | undefined }>;
  country?: string | null;
}

/** "Vehicle preview" — the car as the verification knows it so far, beside
 *  every step but Review (DEV-1902). */
export const VehiclePreview = ({ data }: { data: VehiclePreviewData }) => {
  const flagSrc = data.country ? getCountryFlagSrc(data.country) : undefined;
  return (
    <div className="flex flex-col gap-4">
      <Typography variant="small" className="font-semibold uppercase tracking-wide text-neutral-dark-gray">
        Vehicle preview
      </Typography>
      <div className="rounded-lg bg-neutral-surface-gray p-3">
        <Typography variant="action" className="block text-neutral-black">
          {data.title}
        </Typography>
        <Typography variant="paragraph" className="text-neutral-dark-gray">
          {data.plateLine}
        </Typography>
      </div>
      <dl className="grid grid-cols-2 gap-3">
        {data.rows
          .filter((row) => row.value)
          .map((row) => (
            <div key={row.label} className="contents">
              <dt>
                <Typography className="text-neutral-dark-gray">{row.label}</Typography>
              </dt>
              <dd className="flex items-center justify-end gap-1.5 text-right">
                {row.label === "Country of registration" && flagSrc && (
                  <img src={flagSrc} className="h-4 w-4 rounded-full object-cover" alt="" />
                )}
                <Typography className="text-neutral-black">{row.value}</Typography>
              </dd>
            </div>
          ))}
      </dl>
    </div>
  );
};
